import React from 'react';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// App components
import Loader from './Loader';
import Dashboard from './Dashboard';
// import ScrollView from './ScrollView';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { splashScreen: false };
  }
  
  componentDidMount() {
    const splashTimeout = () => {
      setTimeout(() => {
        this.setState({ splashScreen: true });
      }, 2500);
      clearTimeout(splashTimeout);
    }
    splashTimeout();
  }

  render() {
    const splashScreen = this.state.splashScreen;
    let displayComponent = null;
    // let screenWidth = window.screen.availWidth;

    if (splashScreen) {
      displayComponent = <Dashboard />;
    } else {
      displayComponent = <Loader />;
    }

    return (
      <div>
        {displayComponent}
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js